import * as React from 'react';

const MapPinFillSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="map-pin-fill_svg__24_small_map_pin_fill-a"
                d="M7 0a7 7 0 00-7 7c0 2.015 1.016 3.985 2 5.5.985 1.515 5 7.5 5 7.5s3.985-5.985 5-7.5c1.015-1.515 2-3.485 2-5.5a7 7 0 00-7-7m0 9.5c1.378 0 2.5-1.122 2.5-2.5S8.378 4.5 7 4.5A2.503 2.503 0 004.5 7c0 1.378 1.122 2.5 2.5 2.5"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(5 2)">
            <mask id="map-pin-fill_svg__24_small_map_pin_fill-b" fill="#fff">
                <use xlinkHref="#map-pin-fill_svg__24_small_map_pin_fill-a" />
            </mask>
            <use
                fill="#45494E"
                xlinkHref="#map-pin-fill_svg__24_small_map_pin_fill-a"
            />
            <g mask="url(#map-pin-fill_svg__24_small_map_pin_fill-b)">
                <path fill="#000" d="M-5-2h24v24H-5z" />
            </g>
        </g>
    </svg>
);

MapPinFillSvg.displayName = 'MapPinFillSvg';
export default MapPinFillSvg;
